module.exports = __webpack_public_path__ + "static/media/DownloadMetamask.885082cf.png";